module.exports = __webpack_public_path__ + "static/urban-hut-club-white-420f4a55d2bc3d3a149f54ba0c88852b.svg";